<template>
	<div
		class="content-card"
		:class="classes"
	>
		<LinkWrap :to="to || link">
			<Component
				:is="containerElement"
				class="card-container"
				:to="to || link"
			>
				<ImageResponsive
					v-bind="image"
					v-if="image"
				></ImageResponsive>
				<div class="text">
					<p
						class="categories"
						v-if="categories"
					>
						<span
							v-for="category in categories"
							class="category"
							>{{ category }}</span
						>
					</p>
					<TnHeading
						type="h3"
						size="l"
						class="card-heading padding-bottom-m"
						v-editable-string
						responsive
						>{{ heading }}</TnHeading
					>
					<TnParagraph
						v-if="ingress"
						v-editable-string
						responsive
						>{{ ingress }}</TnParagraph
					>
				</div>
			</Component>
		</LinkWrap>
	</div>
</template>

<script>
export default defineNuxtComponent({
	name: "ArticleTeaser",
	props: ["link", "full-width", "image", "categories", "heading", "ingress", "to"],

	computed: {
		classes() {
			const classes = [];
			if (!this.fullWidth) classes.push("half-width");
			return classes;
		},
		containerElement() {
			return "div";
		},
	},
});
</script>

<style lang="scss" scoped>
.category {
	&::after {
		content: "|";
		display: inline-block;
		margin: 0 3px;
	}

	&:last-child::after {
		content: "";
	}
}

.content-card {
	a {
		text-decoration: none;
	}

	.card-container {
		width: 100%;

		img {
			width: 100%;
		}

		.text {
			padding: 24px 0;
			font-family: $font-family-telenor-ui;
			text-align: left;
			width: 80%;

			.categories {
				margin-bottom: 0;
				max-height: 24px;
				overflow: hidden;
				text-overflow: clip;
				color: $color-text;

				@include font-text-m;

				span {
					display: inline-block;
				}
			}
		}
	}

	@media screen and (width >= 768px) {
		&.half-width {
			.card-container {
				display: inline-flex;

				picture {
					width: 100%;

					img {
						min-height: 300px;
						height: 100%;
						object-fit: cover;
					}
				}

				.text {
					padding-left: 32px;
				}
			}
		}

		&:hover {
			a {
				img {
					opacity: 0.6;
					transition: opacity 0.5s ease-out;
				}

				.card-heading {
					text-decoration: underline;
				}
			}
		}
	}

	@include breakpoint(mobile) {
		.card-container {
			.text {
				width: 100%;

				.categories {
					max-height: 20px;

					@include font-text-xs;
				}
			}
		}
	}
}
</style>
